import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ApiVisa, BudgetVotebookService } from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-budget-votebook-gen-doc",
  templateUrl: "./select-budget-votebook-gen-doc.component.html",
  styleUrls: ["./select-budget-votebook-gen-doc.component.css"],
})
export class SelectBudgetVotebookGenDocComponent implements OnInit, OnDestroy {
  @Input() budgetVotebook = new FormControl();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allBudgetVotebooks: any;
  searchBudgetVotebooks: any = [];

  constructor(private budgetVoteBookService: BudgetVotebookService) {}

  ngOnInit(): void {
    this.subs.sink = this.budgetVoteBookService
      .get(this.apiVisa)
      .subscribe((compResponse) => {
        const compListing = compResponse.data.map((data, index) => ({
          name: data.bl_fi_budget_votebook.name,
          code: data.bl_fi_budget_votebook.code,
          guid: data.bl_fi_budget_votebook.guid,
        }));
        this.allBudgetVotebooks = compListing;
        this.searchBudgetVotebooks = compListing;
      });
  }

  applyBudgetVotebookFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchBudgetVotebooks = this.allBudgetVotebooks.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
